import styled from 'styled-components';
import { Accordion } from 'react-bootstrap';

import { ChevronDown } from '@/assets/icons';

const AccordionTitle = styled.div`
  cursor: pointer;
  font-size: 14px;
  padding: 12px 16px 12px 52px;
  position: relative;

  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: start;

  .progress {
    width: 109px;
    height: 4px;
    margin-left: 16px;

    &-container {
      display: flex;
      flex-direction: row;
      align-items: center;
    }

    // TODO move hex colors to colors.ts (apply to whole application)
    &-variant-success {
      color: #00af46;
    }
    &-variant-danger {
      color: #eb0000;
    }
  }

  &::before {
    content: url(${ChevronDown});
    line-height: 0;
    position: absolute;
    left: 20px;
    transition: transform 0.2s ease-in-out;
  }
`;

const StyledAccordion = styled(Accordion)`
  [data-key='${props => props.activeKey}'] > ${AccordionTitle} {
    &::before {
      transform: rotate(-180deg);
    }
  }

  .collapsed & {
    display: none;
  }
`;

const StyledAccordionItem = styled.div`
  border-bottom: 1px solid #dee2e6;

  &:last-child {
    border-bottom: none;
  }
`;

export { AccordionTitle, StyledAccordion, StyledAccordionItem };
